import { render } from "./MediumApi.vue?vue&type=template&id=20e5585a&scoped=true"
import script from "./MediumApi.vue?vue&type=script&lang=js"
export * from "./MediumApi.vue?vue&type=script&lang=js"

import "./MediumApi.vue?vue&type=style&index=0&id=20e5585a&scoped=true&lang=scss"
import "./MediumApi.vue?vue&type=style&index=1&id=20e5585a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20e5585a"]])

export default __exports__